// src/pages/Invite/InviteBridge.jsx
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { acceptInvite } from "../../api/organizationApi";
import { fetchCurrentUser } from "../../store/userSlice";
import { useToast } from "../../components/Toaster/use-toast";

export default function InviteBridge() {
  const { search } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { toast } = useToast();

  useEffect(() => {
    const qp = new URLSearchParams(search);
    const token = qp.get("token") || qp.get("inviteToken"); // be forgiving

    if (!token) {
      navigate("/not-found", { replace: true });
      return;
    }

    // Try to accept immediately (works even if user is logged out; backend sets cookies)
    acceptInvite({ token })
      .then(async () => {
        // ensure Redux store has the new session
        await dispatch(fetchCurrentUser());

        // success toast
        toast({
          title: "Invite accepted",
          description: "You have joined the organization.",
        });

        navigate("/conversation-type", { replace: true });
      })
      .catch((err) => {
        const msg = err?.response?.data?.error || "";

        // If backend says new user must register, push to /auth carrying token
        if (msg.includes("New users must provide")) {
          navigate("/auth", {
            replace: true,
            state: { inviteToken: token, from: "/conversation-type" },
          });
          return;
        }

        // Already accepted: return to the practice creator with a gentle toast.
        if (/already accepted|already a member/i.test(msg)) {
          toast({
            title: "Already joined",
            description: "You’re already a member of this organization.",
          });
          navigate("/conversation-type", { replace: true });
          return;
        }

        // Invalid/expired or other error → send to auth (optional: show toast)
        toast({
          title: "Invite problem",
          description: msg || "Invalid or expired invite link.",
          variant: "destructive",
        });
        navigate("/auth", { replace: true });
      });
  }, [search, navigate, dispatch, toast]);

  return null; // headless
}
